// extracted by mini-css-extract-plugin
export default {"card":"K0-z","carouselContainer":"L0-z","carouselContent":"M0-z"};